import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import ticketService from "../services/ticketService";
import { toast } from 'react-toastify';

const { TextArea } = Input;

const TicketStatuses = () => {
  const [ticketStatuses, setTicketStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingStatus, setEditingStatus] = useState(null);
  const [deletingStatus, setDeletingStatus] = useState(null);
  const [form] = Form.useForm();

  const fetchTicketStatuses = async () => {
    setLoading(true);
    try {
      const statusList = await ticketService.getAllTicketStatuses();
      setTicketStatuses(statusList);
    } catch {
      message.error("Destek talebi durumları alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingStatus) {
        response = await ticketService.updateTicketStatus({ ...editingStatus, ...values });
      } else {
        response = await ticketService.addTicketStatus(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchTicketStatuses();
      setIsModalOpen(false);
      form.resetFields();
      setEditingStatus(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await ticketService.deleteTicketStatus(id);
      if (response?.Status) {
        toast.success(response?.Message || "Silme işlemi başarılı.");
        fetchTicketStatuses();
      } else {
        toast.error(response?.Message || "Silme işlemi başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchTicketStatuses();
  }, []);

  return (
    <div>
      <h2>Destek Talebi Durumları</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)}>
        Yeni Durum Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={ticketStatuses}
        columns={[
          { title: "Ad", dataIndex: "name" },
          { title: "Açıklama", dataIndex: "description" },
          {
            title: "İşlem",
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingStatus(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingStatus(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle / Güncelle Modal */}
      <Modal
        title={editingStatus ? "Durum Güncelle" : "Durum Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingStatus(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item 
            name="name" 
            label="Durum Adı" 
            rules={[{ required: true, message: 'Durum adı zorunludur' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Onay Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={() => {
          if (deletingStatus) {
            handleDelete(deletingStatus.id);
            setIsDeleteModalOpen(false);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>
          "{deletingStatus?.name}" adlı durum silinecek. Bu işlemi onaylıyor musunuz?
        </p>
      </Modal>
    </div>
  );
};

export default TicketStatuses;